import './scss/main.scss';
import { scrollHeader } from './ts/scrollHeader.js';
import { scrollFooter } from './ts/scrollFooter.js';
import { setupModalClose } from './ts/modalClose.js';
import { language } from './ts/language.js';
import { movieListService } from './ts/ui/movieListService.js';
import { currentLanguage } from './ts/language.js';
import { loginHandler } from './ts/ui/modalLogin.js';
import { registerHandler } from './ts/ui/modalRegister.js';
import { syncListsIfLoggedIn } from './ts/features/devAuthSync.js';
import { handleTrailer } from './ts/playTrailer.js';
import { forgotPasswordHandler } from './ts/ui/modalForgotPassword.js';
import { themeHandler } from './ts/ui/themeHandler.js';
import { showWelcomeAfterLogin } from './ts/ui/welcomeAfterLogin.js';

scrollHeader();
scrollFooter();
setupModalClose();
language();
movieListService(currentLanguage);
syncListsIfLoggedIn();
loginHandler();
registerHandler();
handleTrailer();
forgotPasswordHandler();
themeHandler();
showWelcomeAfterLogin();
